import * as React from 'react';
import cn from 'classnames';
import { Enum, responsiveClasses, useSpacingProps } from '../../../library';
export var columnClasses = {
  COlUMN: 'column',
  GROUP: 'columns'
};
export var ColumnAlignType = Enum({
  TOP: 'top',
  BOTTOM: 'bottom',
  MIDDLE: 'middle',
  BASELINE: 'baseline',
  STRETCH: 'stretch'
});
export var Column = function Column(props) {
  var align = props.align,
    children = props.children,
    offset = props.offset,
    order = props.order,
    span = props.span,
    style = props.style;
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var className = cn(columnClasses.COlUMN, align ? responsiveClasses('-%s', align) : null, offset ? responsiveClasses('-offset-%s', offset) : null, order ? responsiveClasses('-order-%s', order) : null, span ? responsiveClasses('-span-%s', span) : null, marginClasses, paddingClasses, props.className);
  return React.createElement("div", {
    className: className,
    style: style,
    children: children
  });
};
Column.displayName = 'Column';
Column.defaultProps = {};